var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"bv-modal-ajuda","size":"xl","hide-footer":"","centered":"","scrollable":""},model:{value:(_vm.modalData.enabled),callback:function ($$v) {_vm.$set(_vm.modalData, "enabled", $$v)},expression:"modalData.enabled"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.modalData.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }